import { Button, InfoPage, SpinnerCenter } from "@shapr3d/frontend-lib";
import type { MutationStatus } from "@tanstack/react-query";

import useNavigation from "../../hooks/navigation";
import { UserError } from "../../hooks/useAccountTypes";

interface ConfirmEmailChangeProps {
  requestNewChange: () => void;
  state: MutationStatus;
  isLoggedIn: boolean;
  requestError?: UserError;
  newEmail?: string;
}

enum ErrorMessage {
  Expired = "The confirmation link you followed expired in the meantime. Please request a new one.",
  Unknown = "Something went wrong. Please try again.",
}

const ConfirmEmailChange = (props: ConfirmEmailChangeProps) => {
  const navigation = useNavigation();

  const displayedError =
    props.requestError === UserError.InvalidConfirmationHash
      ? ErrorMessage.Expired
      : ErrorMessage.Unknown;

  if (props.state === "pending") {
    return <SpinnerCenter />;
  }

  if (props.state === "error") {
    return (
      <InfoPage
        variant="warning"
        title="Link expired"
        description={displayedError}
        primaryCTA={
          <>
            {props.isLoggedIn && (
              <>
                <Button onClick={props.requestNewChange}>Request another</Button>
                <Button variant="grayscale" onClick={navigation.removeEmailChangeHashParamsFromUrl}>
                  Back to account
                </Button>
              </>
            )}
            {!props.isLoggedIn && (
              <Button onClick={navigation.removeEmailChangeHashParamsFromUrl}>
                Sign in to request another
              </Button>
            )}
          </>
        }
      />
    );
  }

  const buttonText = props.isLoggedIn ? "Back to account" : "Back to login";

  return (
    <InfoPage
      variant="success"
      title="Success!"
      description={`Your email address has been successfully updated to ${props.newEmail}`}
      primaryCTA={
        <Button onClick={navigation.removeEmailChangeHashParamsFromUrl}>{buttonText}</Button>
      }
    />
  );
};

export default ConfirmEmailChange;
